import React from 'react';
import { SimpleTable, } from '@dclab/dc-react-ui-kit';
import INSTRUCTOR from '../../../assets/img/Ellipse_1.png';


function Courses(props) {

    const style = {
        width: '100%',
    };



    // ============================== Table Start ======================================//
    let col = [

        { type: 'link', name: 'frequency', label: 'COURSE', width: '30%' },
        { type: 'string', name: 'date', label: 'STATUS', width: '15%' },
        { type: 'string', name: 'date', label: 'INSTRUCTOR', width: '15%' },
        { type: 'string', name: 'date', label: 'STARTED', width: '20%' },
        { type: 'string', name: 'date', label: 'ENDED', width: '25%' },
        { type: 'action', label: 'ACTION', width: '10%' }

    ];

    const selected_categories = col.sort((a, b) => a.order - b.order)
    let rows = selected_categories.map((text, index) => {
        let i = index + 1
        return (
            [
                {
                    name: 'textImg',
                    type: 'string',
                    primaryText: 'Learn Quran in 24 hours Sheikh Muhammad Jamal Uddin',
                    initials: 'HK',
                },
                { type: 'string', name: 'date', value: 'Running' },
                { name: 'textImg', type: 'string', src: INSTRUCTOR, },
                { type: 'string', name: 'date', value: 'Mar 30, 2022' },
                { type: 'string', name: 'date', value: 'Mar 30, 2022' },
                { type: 'action', status: 'success', value: 'see details' },

            ]
        )
    })


    // ============================== Table End ======================================//

    return (

        <div className="table_box">
            <SimpleTable
                showHeader={true}
                title="Courses"
                width="100%"
                rows={rows}
                columns={col}
                colSpan={16}
                actionSendButton={true}
                donationsCount={rows && rows.length > 0 ? 1 : 0}
                noTitle="No inquiry submitted yet"
                noPara="Inquiries submitted by visitors will be visible and managed here."
                noBtnText=""
                onInviteClick={() =>
                    props.history.push(
                        "/education/order-details"
                    )
                }
                actionLink={(name) => props.history.push({ pathname: "/education/order-details", state: { contact: name[0].data } })}
                showIconCol={false}
                deleteAction={(e) => console.log(e)}
                showFooter={true}
                showFilter={true}
                filterText='Filter'
                addText="FILTER"
                onAddClick={() => props.history.push("/nikah/nikah-details")}
            />
        </div>

    );
}


export default Courses;